export const PRODUCT_FIRST_WORKFLOWS = [
  'product_first_scan_to_put_wall',
  'multi_put_wall'
];

export function isProductFirstWorkflow(scanPackWorkflow) {
  return PRODUCT_FIRST_WORKFLOWS.includes(scanPackWorkflow);
}

export function isMultiPutWall(scanPackWorkflow) {
  return scanPackWorkflow === 'multi_put_wall';
}

export function getScanEntryRoute(scanPackWorkflow) {
  return isProductFirstWorkflow(scanPackWorkflow) ? 'PutWall' : 'ScanPack';
}
